export enum AppLocale {
  en = 'en',
  pl = 'pl',
}
